import { render, staticRenderFns } from "./MenuConversationV2.vue?vue&type=template&id=4c2efc06&scoped=true"
import script from "./MenuConversationV2.vue?vue&type=script&lang=js"
export * from "./MenuConversationV2.vue?vue&type=script&lang=js"
import style0 from "./MenuConversationV2.vue?vue&type=style&index=0&id=4c2efc06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2efc06",
  null
  
)

export default component.exports